export const trimStringsInObject = (obj) => {
    if (typeof obj === 'string') return obj.trim();
    if (Array.isArray(obj)) return obj.map(trimStringsInObject);
    if (obj && typeof obj === 'object') {
        return Object.fromEntries(
            Object.entries(obj).map(([k, v]) => [k, trimStringsInObject(v)])
        );
    }
    return obj;
};

// Ménage des locaux et arrosage : usages rapportés à une surface (m²). Testé sur
// les ids du référentiel, les libellés pouvant être renommés ; `type_usage` reste
// un repli pour les usages historiques sans sous-catégorie.
export const usageHasSurface = (usage) =>
    usage.usage_subcategory_id === 'entretien_nettoyage--menage'
    || usage.usage_category_id === 'espaces_verts'
    || usage.type_usage === 'Ménage'
    || usage.type_usage === 'Arrosage';

export const applyWaterValue = (data) => {
    const d = { ...data, technical_data: { ...data.technical_data } };

    if (d.type_equipment === 'faucet' || d.type_equipment === 'shower') {
        if (d.technical_data.activation_mode === 'push_button' && d.technical_data.timer_duration) {
            d.technical_data.timer_duration /= 60;
        }
        d.water_value = d.technical_data.max_flow;
        d.water_value_unit = d.technical_data.max_flow_unit;
    }

    if (d.type_equipment === 'wc') {
        const ft = d.technical_data.flush_type;
        if (ft === 'dual_flush') {
            d.water_value = (3 * d.technical_data.flush_volume_min + d.technical_data.flush_volume_max) / 4;
            d.water_value_unit = 'L/cycle';
        } else if (ft === 'simple_flush') {
            d.water_value = d.technical_data.flush_volume_max;
            d.water_value_unit = 'L/cycle';
        } else if (ft === 'interruptible_flush') {
            d.water_value = d.technical_data.flush_flow;
            d.water_value_unit = 'L/min';
        }
    }

    if (d.type_equipment === 'urinal') {
        d.water_value = d.technical_data.flush_volume;
        d.water_value_unit = 'L/cycle';
    }

    if (d.type_equipment === 'machine') {
        d.water_value = d.technical_data.volume_per_cycle;
        d.water_value_unit = d.technical_data.volume_per_cycle_unit || 'L/cycle';
    }

    return d;
};
